module.exports = __webpack_public_path__ + "static/media/ana_negra.65987c2e.png";